let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import i18n from "../../utils/i18n";
import ValidationView from "../comp/ValidationView.js";
import POS from "../../POS.js";
let BillNotesView = require("./BillNotesView.js");
let moment = require("moment");
import ModalView from "../comp/ModalView.js";
import qq from 'fine-uploader'
let DbRecorder = require("../../recorder/DbRecorder.js");


let main = function () {
    return Backbone.View.extend({
        events: {
            "click .basic .save": "saveBasic",
            "click .posSetting .save": "savePos",
            "click .nav li": 'selectPanel',
            "click .websave": 'saveWebOrderSetting',
            "click .weixinsave": 'saveWeixin',
            "click .advancedSettings .save": 'savePing',
            "click .currencyExchangeSettings .save": 'saveExchangeSettings',
            "click .advancedSettings .clear-local": 'clearLocalStorage',
            "click .posSetting .note-setting .create": 'saveNote',
            "click .posSetting .note-setting .delete": 'deleteNote',
            "change .hour-form select": "_changeHourItem",
            "keyup input.urlCode": "_updateUrlCode",
            "change select.stopNow": "refreshTakeoutAlert",
            //"click .qq-upload-button": "removeAlertSuccess",
            "click .add-weixin": "_addWeixin",
            'click .modal .btn-close': '_closeWeixin',
            'change .analyticsEndTime': 'limitAnalyticsEndTime',
            'click .radio-btn': '_clickRadio',
            'click .check-box': '_clickCheckbox',
            'change textarea.address': '_address_change',
            'keyup textarea.address': '_address_change',
            "click .getQRCode": 'getWeixinQRCode',
            "click .createMenu": 'createWeixinMenu',
            "click .weixinMenuSave": 'saveWeixinMenu',
            "click .editWeixinMenu textarea": 'editWeixinMenu',
            "click .pickupAddressBtn": 'showPickupAddressModal',
            "click .createPickupAddressModal .saveCreate-btn": 'savePickupAddress',
            "click .weborder-time": 'showTakeOutSetting',
            "click .takeOutHoursEditor .saveCreate-btn": 'saveTakeOutSetting',
            "click .takeOutHoursEditor .deleteTakeOutItem": 'deleteTakeOutSetting',
            "click .editPickupAddress": 'showEditPickupAddressModal',
            "click .createPickupAddressModal .saveEdit-btn": 'updatePickupAddress',
            "click .createPickupAddressModal .delete": 'deletePickupAddress',
            "change .fee-setting .fee": 'feeCheck',
            "change select.country": "_countryCodeChanged",
            "click .weixin.panel .weixinBasic .showAdvance": 'showWeixinSettings',
            "click .weixin.panel .cashWithdrawal": 'cashWithdrawal'
        },

        initialize: function () {
            if (!this.model) {
                this.model = new Backbone.Model();
            }

            if (this.el) {
                //setup the restuarant id
                this.model.id = this.$el.data('id');
                this._initializeUploader();
                if(this.$el.find('.weixin').length>0){
                    this._initWeixinCertUploader();
                }
                this.billNoteView = new BillNotesView({el: this.$(".note-history")});
                this.$el.find('.country-switch .country').val(POS.getRestaurant().get('countryCode'));
                if(!window.AndroidClient){
                    $(".posSetting .invoiceEnabled").hide();
                }
            }
            this.lazy_update_map = _.debounce(_.bind(this._lazy_update_map, this), 1000);
        },
        _clickRadio: function (event) {
            var _this = $(event.currentTarget),
                block = _this.closest(".form-group");
            if(block.hasClass("round-amount")){
                if(this._checkTableStatus()){
                    alert(i18n.msg("pos.checkTableStatus.tip"));
                    return false;
                }
            }
            block.find('input:radio').attr('checked', false);
            block.find(".radio-btn").removeClass('checkedRadio');
            _this.addClass('checkedRadio');
            _this.find('input:radio').attr('checked', true);
        },

        _clickCheckbox: function (event) {
            var _this = $(event.currentTarget),
                checkbox = _this.find(':checkbox');
            checkbox.attr('checked', !checkbox.attr('checked'));
            _this.toggleClass('checkedBox');
            if (checkbox.attr("name") == 'useStripe') {
                this._useStripe_change(event);
            }
        },

        _addWeixin: function () {
            var modal = this.$('.modal');
            modal.show();
        },
        _closeWeixin: function () {
            var modal = this.$('.modal');
            modal.hide();
        },
        _validateHourItem: function (form) {
            $(form).removeClass("has-error");
            var start = $(form).find("input[name=start]").val();
            var end = $(form).find("input[name=end]").val();
            if ($.trim(start) == "" || $.trim(end) == "" || !(/\d{3,4}/.test(start)) || !(/\d{3,4}/.test(end))) {
                $(form).addClass("has-error");
                return false;
            }
            return true;
        },
        _changeHourItem: function (event) {
            var element = $(event.currentTarget);
            element.closest(".input-group").find("input[type=hidden]").val(
                element.closest(".input-group").find(".hour-width").val() +
                element.closest(".input-group").find(".minute-width").val());
        },

        _checkTableStatus:function(){
            var result = POS.getTables().filter(function(table){return !table.isEmpty()});
            return result.length > 0;
        },

        feeCheck:function(evt){
            if(this._checkTableStatus()){
                $(evt.currentTarget).val(POS.getRestaurant().get("fee"));
                alert(i18n.msg("pos.checkTableStatus.tip"));
                return false;
            }
        },
        _initializeUploader: function () {
            var self = this;
            console.log("uploading...");
            new qq.FineUploader({
                    element: self.$(".upload-wrapper")[0],
                request: {
                    endpoint: '/photo/upload',
                    params: {
                        targetId: self.model.id ? self.model.id : 0,
                        type: 'RESTAURANT_LOGO_ORIGINAL'
                    }
                },
                multiple: false,
                callbacks: {
                    onComplete: function (id, fileName, responseJSON) {
                        console.log("uploaded", responseJSON);
                        if (responseJSON.success) {
                            self.$(".itemPhoto").css("background-image", "url(" + responseJSON.src + ")");
                            self.$(".photo-filename").val(fileName);
                        } else {
                            if (responseJSON.code == 1) {
                                alert(i18n.msg("pos.file.size.over.1m"));
                            } else if (responseJSON.code == 2) {
                                alert(i18n.msg("pos.restaurant.logo.must.be.square"));
                            }
                        }
                    }
                },
                debug: true,
                text: {
                    uploadButton: self.$(".upload-wrapper").text()
                }
            });
        },

        _initWeixinCertUploader: function() {
            var self = this;
           new qq.FineUploader({
                element: self.$(".wx-upload-wrapper")[0],
                request: {
                    endpoint: '/tooieWeixin/upload',
                    params: {
                        rId: POS.getRestaurant().id,
                        type: 'WEIXIN_CERT'
                    }
                },
                multiple: false,
                callbacks: {
                    onComplete: function (id, fileName, responseJSON) {
                        if (responseJSON.success) {
                            alert('证书上传完成');
                        } else {
                            alert('证书上传失败');
                        }
                    }
                },
                debug: true,
                text: {
                    uploadButton: self.$(".wx-upload-wrapper").text()
                }
            });
        },

        render: function () {
            if (this.settingTag.length != 0) {
                $(".nav-tabs").find("." + this.settingTag).click();
            }
            if (this.$("textarea.address").val() && this.$("textarea.address").val().length > 0) {
                this._address_change();
            }
            return this;
        },

        saveBasic: function () {
            this.$('.basic .alert-success').addClass('hidden');
            this.clear();
            this.validate();
            if (this.$('div.basic form .has-error').size() > 0) {
                return false;
            }
            var params = this.$('div.basic form').serialize(),
                result = $.post('/restaurant/update/' + this.model.id, params), self = this;
            POS.showLoading(true);
            result.done(function (res) {
                self.savePhoto();
                self.saveAnalyticsEndTime();
                self.$('.has-error').removeClass('.has-error');
                $('.saveSuccessDiv').removeClass('hidden');
                setTimeout(function () {
                    $('.saveSuccessDiv').addClass('hidden')
                }, 1000);
                self.trigger('needRefresh');
            });
            result.fail(function () {

            });
            result.always(function (response) {
                POS.showLoading(false);
            });
            return false;
        },

        //在基本信息设置中点击上传图片的按钮，将设置成功的提示隐藏
        //removeAlertSuccess: function () {
        //    this.$('.basic .alert-success').addClass('hidden');
        //},

        savePos: function () {
            this.$('.posSetting .alert-success').addClass('hidden');
            this.clear();
            this.validate();
            var fee = $('.posSetting .fee-setting .fee').val();
            if (fee > 99 || fee < 0) {
                this.$(".fee-setting").addClass("has-error");
                this.$(".fee-setting .fee").siblings(".help-block").text(i18n.msg("pos.settings.fee.range"));
            }
            if (this.$('div.posSetting form .has-error').size() > 0) {
                return false;
            }

            var params = this.$('div.posSetting form').serialize();
            this.$('div.posSetting form .radio-btn.checkedRadio input').each(function(index, n) {
                if (params.indexOf($(n).attr("name")) < 0) {
                    params = params + "&" + $(n).attr("name") + "=" + $(n).attr("value");
                }
            });
            var result = $.post('/restaurant/updatePOS/' + this.model.id, params), self = this;
            POS.showLoading(true);
            result.done(function (res) {
                self.$('.has-error').removeClass('.has-error');
                $('.saveSuccessDiv').removeClass('hidden');
                setTimeout(function () {
                    $('.saveSuccessDiv').addClass('hidden')
                }, 1000);
                self.trigger('needRefresh');
            });

            result.fail(function () {

            });
            result.always(function (response) {
                POS.showLoading(false);
            });
            return false;
        },

        clear: function () {
            var form = this.$('div.basic form');
            form.find('.has-error').removeClass("has-error");
            form.find('.help-block').empty();
        },

        validate: function () {
            var nameValidator = new ValidationView({el: this.$('.rName')}),
                telephoneValidator = new ValidationView({el: this.$('.telephone')}),
                addressValidator = new ValidationView({el: this.$('.address')});

            if (!nameValidator.notEmpty().excludeHTML().isValid()) {
                nameValidator.render();
            }

            if (!telephoneValidator.notEmpty().excludeHTML().isValid()) {
                telephoneValidator.render();
            }

            if (!addressValidator.excludeHTML().isValid()) {
                addressValidator.render();
            }
        },

        selectPanel: function (evt) {
            var panel = $(evt.currentTarget);
            this.$('.nav li, .panel').removeClass('active');
            this.$('.alert-success:not(.info)').addClass('hidden');
            panel.addClass('active');

            if (panel.find('a').hasClass('weborder')) {
                this.$('div.weborder').addClass('active');
            } else if (panel.find('a').hasClass('basic')) {
                this.$('div.basic').addClass('active');
            } else if (panel.find('a').hasClass('weixin')) {
                this.$('div.weixin').addClass('active');
            } else if (panel.find('a').hasClass('bar')) {
                this.$('div.bar').addClass('active');
            } else if (panel.find('a').hasClass('posSetting')) {
                this.$('div.posSetting').addClass('active');
            } else if (panel.find('a').hasClass('advancedSettings')) {
                this.$('div.advancedSettings').addClass('active');
            }
        },

        refreshTakeoutAlert: function () {
            // Refresh takeout alert
            if (this.$('div.weborder select.stopNow').find(':selected').data("value") == 'NO') {
                self.$(".alert-warning").removeClass("hidden");
                self.$(".alert-success").addClass("hidden");
            } else {
                self.$(".alert-warning").addClass("hidden");
                self.$(".alert-success").removeClass("hidden");
            }
        },

        saveWebOrderSetting: function () {
            this.$('.has-error').removeClass('has-error');
            this.$('.help-block').text('');

            var form = this.$('div.weborder form'),
                self = this, item = $('.weborder .businessHours'),
                startminute = item.find(".start-minute").val().length == 1? "0"+item.find(".start-minute").val():item.find(".start-minute").val(),
                endminute = item.find(".end-minute").val().length == 1? "0"+item.find(".end-minute").val():item.find(".end-minute").val(),
                hourItems = item.find("input[name=id]").val() + ";" + item.find(".start-hour").val() + startminute + ";" + item.find(".end-hour").val() + endminute,
                params = {
                    lda: form.find('.lda').val(), postage: form.find('.postage').val(),
                    stopNow: !this.$("div.weborder input[name='stopNow']").attr("checked"),
                    hideWishTime: this.$("div.weborder input[name='hideWishTime']").prop("checked"),
                    selfPickupAble: this.$("div.weborder input[name='selfPickupAble']").prop("checked"),
                    canDeliver: this.$("div.weborder input[name='canDeliver']").prop("checked"),
                    orderWithoutSignInDisabled: !this.$("div.weborder input[name='orderWithoutSignInDisabled']").prop("checked"),
                    deliveryNote: this.$("div.weborder .deliveryNote").val(),
                    urlCode: this.$('div.weborder input[name="urlCode"]').val().trim(),
                    restaurantId: this.model.id,
                    useStripe: this.$('div.weborder input[name="useStripe"]').is(":checked"),
                    stripePublicKey: this.$('div.weborder input[name="stripePublicKey"]').val().trim(),
                    stripeSecretKey: this.$('div.weborder input[name="stripeSecretKey"]').val().trim()
                }, result = null;


            if (params.urlCode.indexOf(' ') > 0 || params.urlCode.length > 30 || params.urlCode.match(/[.*@%#?=&]/g)) {
                self.$('.urlCodeGroup').addClass('has-error');
                self.$('.urlCodeGroup .help-block').text(i18n.msg('pos.settings.r.web.urlCode.error.format'));
                return false;
            }

            if (params.useStripe && (!params.stripePublicKey || params.stripePublicKey.length == 0)) {
                self.$('.stripePublicKeyBlock').addClass('has-error');
                self.$('.stripePublicKeyBlock .help-block').text(i18n.msg('pos.settings.r.stripe.publicKeyError'));
                return false;
            }

            if (params.useStripe && (!params.stripeSecretKey || params.stripeSecretKey.length == 0)) {
                self.$('.stripeSecretKeyBlock').addClass('has-error');
                self.$('.stripeSecretKeyBlock .help-block').text(i18n.msg('pos.settings.r.stripe.privateKeyError'));
                return false;
            }

            params.hourItems = hourItems;

            result = $.post('/restaurant/updateWebOrderSetting', params);
            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    console.log(res.setting.stopNow);
                    if (!res.setting.stopNow) {
                        self.$('.alert-success').removeClass('hidden');
                        self.$('.alert-warning').addClass('hidden');
                    } else {
                        self.$('.alert-success').addClass('hidden');
                        self.$('.alert-warning').removeClass('hidden');
                    }
                    self.$("div.weborder input[name='stopNow']").attr("checked",!res.setting.stopNow)
                    self.$('.has-error').removeClass('.has-error');
                    self.$('.help-block').text('');
                    $('.saveSuccessDiv').removeClass('hidden');
                    setTimeout(function () {
                        $('.saveSuccessDiv').addClass('hidden')
                    }, 1000);
                    self.trigger('needRefresh');
                } else {
                    console.log('settings update error');

                    if (res.errors) {
                        console.log(res.errors);
                        var errors = res.errors.errors;
                        self.$('.' + errors[0].field + 'Group').addClass('has-error');
                        self.$('.' + errors[0].field + 'Group .help-block').text(i18n.msg('pos.settings.r.web.urlCode.error'));
                    }
                }

            });

            result.fail(function () {

            });
            result.always(function (response) {
                POS.showLoading(false);
            });
            return false;
        },

        savePhoto: function () {

            var self = this, form = this.$('div.logo form'), paramsLogo = {src: true}, jxhr;
            paramsLogo.filename = self.$(".photo-filename").val();

            if (!paramsLogo.filename) {
                return;
            }
            paramsLogo.restaurantId = self.model.id;
            jxhr = $.post("/restaurant/uploadLogo", paramsLogo);
            POS.showLoading(true);
            jxhr.done(function (response) {
                self.$(".itemPhoto").css("background-image", "url(/photo/restaurant/" + self.model.id + "?type=big&seed=" + Math.random() + ")");
            });

            jxhr.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });
            jxhr.always(function (response) {
                POS.showLoading(false);
            });
        },

        saveAnalyticsEndTime: function () {
            var self = this;
            var startHour = self.$('.analyticsEndTime .start-hour').val();
            var startMinute = self.$('.analyticsEndTime .start-minute').val();
            var analyticsTimeTag = self.$('.analyticsEndTime .tag').val();
            var endTime = startHour + ":" + startMinute;
            var params = {};
            params.restaurantId = self.model.id;
            params.endTime = endTime;
            params.tag = analyticsTimeTag;
            POS.showLoading(true);
            var jxhr = $.post("/restaurant/updateAnalyticsEndTime", params);
            jxhr.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });
            jxhr.always(function (response) {
                POS.showLoading(false);
            });
        },

        limitAnalyticsEndTime: function () {
            var self = this;
            var startHour = self.$('.analyticsEndTime .start-hour').val();
            if (startHour == 24) {
                self.$('.analyticsEndTime .start-minute option[value = 0]').prop("selected", "selected");
                self.$('.analyticsEndTime .start-minute option:not([value = 0])').addClass('hidden');
            } else {
                self.$('.analyticsEndTime .start-minute option').removeClass('hidden');
            }
        },

        saveWeixinOrderSuccessPicture: function () {
            var self = this, form = this.$('div.weixin form'), params = {src: true}, jxhr;
            params.filename = self.$(".weixin-photo-filename").val();

            if (!params.filename) {
                return;
            }
            params.restaurantId = self.model.id;
            POS.showLoading(true);
            jxhr = $.post("/restaurant/updateWeixinOrderPicture", params);
            jxhr.done(function (response) {
                self.$(".weixinPhoto").css("background-image", "url(/photo/restaurantWeixinOrderSuccessPicture/" + self.model.id + "?seed=" + Math.random() + ")");
            });

            jxhr.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });
            jxhr.always(function (response) {
                POS.showLoading(false);
            });
        },

        getWeixinQRCode: function() {
            console.log('show QRCode');
            POS.showLoading(true);
            var result = $.post('/tooieWeixin/getWeixinQRCode', {rId: POS.getRestaurant().id});

            result.done(function(res) {
                console.log('received code', res);
                if(res.url) {
                    var modal = $('.addWeixin.modal');
                    modal.find('.qrImg').attr('src', res.url);
                    modal.show();

                } else {
                    alert('无法获取二维码注册, 请联系客服人员');
                }
            });

            result.fail(function(res) {
                alert('无法获取二维码注册, 请联系客服人员');
            });

            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        createWeixinMenu: function (evt) {
            console.log('create weixin menu');
            POS.showLoading(true);
            var result = $.post('/businessAccount/showMenuScript',
                {id: $(evt.target).data('id'), rId: POS.getRestaurant().id, returnType: 'json'});

            result.done(function (res) {
                console.log(res.menu);
                var modal = $('.editWeixinMenu.modal');
                modal.find('textarea').val(res.menu);
                modal.show();

                /*if(res.success) {
                 alert('微信功能重置成功！');
                 } else {
                 alert('无法重置微信功能，请联系客服人员');
                 }*/
            });

            result.fail(function(res) {
                alert('无法重置微信功能，请联系客服人员');
            });

            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        saveWeixinMenu: function (evt) {
            console.log('create weixin menu');
            POS.showLoading(true);
            var result = $.post('/businessAccount/createMenu', {
                id: $(evt.target).data('id'),
                rId: POS.getRestaurant().id,
                menu: this.$('.editWeixinMenu textarea').val()
            });

            result.done(function (res) {
                if (res.success) {
                    $('.editWeixinMenu.modal').hide();
                } else {
                    alert('无法重置微信功能，请联系客服人员');
                }
            });

            result.fail(function (res) {
                alert('无法重置微信功能，请联系客服人员');
            });

            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        clearLocalStorage:function(){
            var appId = DbRecorder.read("chromeAppId");
            var seenHelp = DbRecorder.read("seenHelp");
            var networkPrinterSetting = localStorage.getItem("networkPrinterSetting") ? JSON.parse(localStorage.getItem("networkPrinterSetting")) : [];
            localStorage.clear();
            DbRecorder.save("chromeAppId", appId);
            DbRecorder.save("seenHelp", seenHelp);
            localStorage.setItem("networkPrinterSetting", JSON.stringify(networkPrinterSetting));
            POS.makeHideConfirm();
            _.delay(function () {
                window.location.reload();
            }, 1000);
            return false;
        },
        savePing: function () {
            var self = this, result, params = {
                pingKey: $(".advancedSettings .pingKey").val(),
                appId: $(".advancedSettings .pingAppId").val()
            };
            result = $.post("/restaurant/updatePingSetting", params);

            result.done(function (res) {
                if (res.success) {
                    $('.saveSuccessDiv').removeClass('hidden');
                    setTimeout(function () {
                        $('.saveSuccessDiv').addClass('hidden')
                    }, 1000);
                    self.trigger('needRefresh');
                } else {
                    alert(i18n.msg('pos.serverError'));
                }
            });

            result.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });

            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        saveExchangeSettings: function () {
            var self = this, result, params = {
                baseRuleId: $(".currencyExchangeSettings .generateRatio").data("id"),
                generateRatio: $(".currencyExchangeSettings .generateRatio").val(),
                scoreRuleId: $(".currencyExchangeSettings .exchangeRatio").data("id"),
                exchangeRatio: $(".currencyExchangeSettings .exchangeRatio").val()
            };
            result = $.post("/restaurant/updateCurrencyExchangeRule", params);

            result.done(function (res) {
                if (res.success) {
                    $('.saveSuccessDiv').removeClass('hidden');
                    setTimeout(function () {
                        $('.saveSuccessDiv').addClass('hidden')
                    }, 1000);
                    self.trigger('needRefresh');
                } else {
                    alert(i18n.msg('pos.serverError'));
                }
            });

            result.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });

            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        saveWeixin: function () {
            var params = this.$('.weixin form').serialize();
            var receiveWeixinBill = this.$(".receiveWeixinBill").prop("checked"), result, self = this;
            console.log('receive weixin bill ' + receiveWeixinBill);

            if (self.$('.modal').css("display") != 'none') {
                receiveWeixinBill = self.$(".receiveWeixinBill.inModal").prop("checked")
            }

            params = params +'&id='+POS.getRestaurant().id;
            POS.showLoading(true);
            self.$(".weixin.panel .alert-success").addClass('hidden');
            console.log(params);
            result = $.ajax({url: '/restaurant/updateWebOrderWeixinSetting', type:'post', data: params});

            result.done(function (res) {
                if (res.success) {
                    self.saveWeixinOrderSuccessPicture();
                    $('.saveSuccessDiv').removeClass('hidden');
                    setTimeout(function () {
                        $('.saveSuccessDiv').addClass('hidden')
                    }, 1000);
                    $('.weixin .info').removeClass('hidden');
                    $('.weixin-config-url').html(res.weixinConfigURL);
                    self.trigger('needRefresh');
                    self._closeWeixin();
                } else {
                    alert(i18n.msg('pos.serverError'));
                }
            });

            result.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });

            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        saveNote: function (evt) {
            var note = this.$('.note-setting textarea').val(), result, self = this;
            self.$(".note-setting .alert-success").addClass('hidden');
            if (note.trim().length == 0) {
                alert(i18n.msg('pos.settings.r.paymentNote.addAlert'));
                return;
            }

            if (this.$('.note-setting li').size() > 10) {
                alert(i18n.msg('pos.settings.r.paymentNote.maxError'));
                return;
            }

            result = $.post('/paymentNote/create', {id: POS.getRestaurant().id, content: note});
            POS.showLoading(false);
            result.done(function (res) {
                if (res.success) {
                    var newNote = self.$('.note-setting li.template').clone().addClass('pitem').removeClass('hidden').removeClass('template');
                    newNote.find('span').text(note);
                    newNote.attr('data-id', res.id);
                    self.$('.note-setting ul').append(newNote);
                    self.$('.note-setting textarea').val('');
//                        self.$(".note-setting .alert-success").removeClass('hidden');
                    self.trigger('needRefresh');
                } else {
                    alert(i18n.msg('pos.serverError'));
                }
            });

            result.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        deleteNote: function (evt) {
            var self = this,
                note = $(evt.currentTarget).closest('li'),
                result = $.post('/paymentNote/delete', {id: note.data('id')});
            self.$(".note-setting .alert-success").addClass('hidden');
            POS.showLoading(true);
            result.done(function (res) {
                console.log('delete return');

                if (res.success) {
                    note.remove();
                    self.billNoteView.render();
//                        self.$(".note-setting .alert-success").removeClass('hidden');
                    self.trigger('needRefresh');
                } else {
                    alert(i18n.msg('pos.serverError'));
                }
            });

            result.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        _updateUrlCode: function (evt) {
            var prefix = this.$('a.urlCode').data("prefix");
            this.$('a.urlCode').attr("href", prefix + "/c/" + $(evt.target).val());
            return false;
        },

        _address_change: function () {
            this.lazy_update_map();
        },

        _lazy_update_map: function () {
            if (POS.getRestaurant().get('countryCode') == '86') {
                return;
            }
            this.$(".map").hide();
            var iframe = $("<iframe frameborder='0' style='border:0' width='320' height='200'/>");
            this.$(".map").empty();
            iframe.on("load", _.bind(function () {
                this.$(".map").show();
            }, this));
            iframe.appendTo(this.$(".map"));
            iframe.attr('src', 'https://www.google.com/maps/embed/v1/place?key=AIzaSyDH1qgAbgO35h0CTmoCYWCA58eFYsb8FEU&q='
                + encodeURIComponent(this.$("textarea.address").val()));
        },

        _useStripe_change: function () {
            var checkbox = this.$("input[name=useStripe]");
            console.log('use stripe?', checkbox.attr("checked") == 'checked');

            var useStripe = checkbox.attr("checked") == 'checked';
            this.$(".form-group.stripeGroup").toggleClass("hidden", !useStripe);
        },

        editWeixinMenu: function(evt) {
            console.log("textarea clicked " + evt.keyCode);
            if(evt.shiftKey) {
                $(evt.target).prop('readonly', '');
            }
        },

        showTakeOutSetting:function(){
            this.$('.modal.takeOutHoursEditor').modal('show');
        },

        showPickupAddressModal: function() {
            var modal = this.$('.modal.createPickupAddressModal');
            modal.modal('show');
            this.$('.modal.createPickupAddressModal .newAddress').val('');
            if (modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').removeClass('saveEdit-btn');
            }
            if (!modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').addClass('saveCreate-btn');
            }
            modal.find('.delete').addClass('hidden');
        },

        showEditPickupAddressModal: function(evt){
            var address = $(evt.currentTarget),modal = this.$('.modal.createPickupAddressModal');
            modal.modal('show');
            this.$('.modal.createPickupAddressModal .newAddress').val(address.text());
            this.$('.modal.createPickupAddressModal .editAddress').data('id',address.attr('id'));
            if (modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').removeClass('saveCreate-btn');
            }
            if (!modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').addClass('saveEdit-btn');
            }
            modal.find('.delete').removeClass('hidden');
        },

        deleteTakeOutSetting:function(evt){
            POS.showLoading(true);
            var self = this, item = $(evt.currentTarget),jxhr;
            jxhr = $.post("/restaurant/deleteTakeOutTime",{rId:POS.getRestaurant().id,
                itemId:item.data("id")});
            jxhr.done(function(res){
                if(res.success){
                    item.closest("div").remove();
                }else{
                }
            });
            jxhr.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });

            jxhr.always(function (response) {
                POS.showLoading(false);
            });
        },

        saveTakeOutSetting:function(){
            POS.showLoading(true);
            var jxhr,item = $(".takeOutHoursEditor"),
                startminute = item.find(".start-minute").val().length == 1? "0"+item.find(".start-minute").val():item.find(".start-minute").val(),
                endminute = item.find(".end-minute").val().length == 1? "0"+item.find(".end-minute").val():item.find(".end-minute").val(),
                hourItems  = item.find(".start-hour").val() + startminute + ";" + item.find(".end-hour").val() + endminute;
            if(parseInt(hourItems.split(";")[0])<=parseInt(hourItems.split(";")[1])){
                alert("截止时间不应早于订餐时间!");
                POS.showLoading(false);
                return;
            }
            jxhr = $.post("/restaurant/updateTakeOutTime",{rId:POS.getRestaurant().id,
                hourItems:hourItems});
            jxhr.done(function(res){
                if(res.success){
                    $(".takeout-timezone .takeout-label").after("<div>" +
                        "<label>"+new moment(res.item.takeoutTime).format('HH:mm')+"</label>" +
                        "<label>"+new moment(res.item.deadlineTime).format('HH:mm')+"</label>" +
                        "<img src='/images/pos/deleteNoteImg.png' class='deleteTakeOutItem' data-id='"+res.item.id+"'/>" +
                        "</div>")
                }else{
                    alert("订餐时间已存在");
                }
            });
            jxhr.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });

            jxhr.always(function (response) {
                POS.showLoading(false);
            });
        },

        savePickupAddress: function() {
            POS.showLoading(true);
            var address=this.$('.modal.createPickupAddressModal .newAddress').val(),
                jxhr = $.post("/restaurant/updatePickupAddress", {rId: POS.getRestaurant().id,
                    address:address}), self = this;

            jxhr.done(function(res) {
                if(res.success) {
                    self.$('.modal.createPickupAddressModal').modal('hide');
                    var item = self.$('.editPickupAddress:first').parent().clone();
                    if(item.attr('id')){
                        item.find('.editPickupAddress').attr('id', res.addressId).text(address);
                    } else {
                        item = "<li><a href='#' id="+res.addressId+" class='editPickupAddress'>"+address+"</a></li>";
                    }
                    self.$('.pickupAddressList').append(item);
                } else {
                    alert(i18n.msg('pos.serverError'));
                }
            });

            jxhr.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });

            jxhr.always(function (response) {
                POS.showLoading(false);
            });

        },

        updatePickupAddress: function(){
            POS.showLoading(true);
            var address=this.$('.modal.createPickupAddressModal .newAddress').val(),addressId =this.$('.modal.createPickupAddressModal .editAddress').data('id'),
                jxhr = $.post("/restaurant/editPickupAddress", {rId: POS.getRestaurant().id,
                    address:address,addressId:addressId}),self = this;

            jxhr.done(function(res) {
                if(res.success) {
                    self.$('.modal.createPickupAddressModal').modal('hide');
                    self.$('.editPickupAddress[id='+addressId+']').text(address);
                } else {
                    alert(i18n.msg('pos.serverError'));
                }
            });

            jxhr.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });

            jxhr.always(function (response) {
                POS.showLoading(false);
            });
        },

        deletePickupAddress: function(){
            POS.showLoading(true);
            var addressId=this.$('.modal.createPickupAddressModal .editAddress').data('id'),
                jxhr = $.post("/restaurant/deletePickupAddress", {rId: POS.getRestaurant().id,
                    addressId:addressId}),self = this;

            jxhr.done(function(res) {
                if(res.success) {
                    self.$('.modal.createPickupAddressModal').modal('hide');
                    self.$('.editPickupAddress[id='+addressId+']').hide();
                } else {
                    alert(i18n.msg('pos.serverError'));
                }
            });

            jxhr.fail(function (response) {
                alert(i18n.msg('pos.serverError'));
            });

            jxhr.always(function (response) {
                POS.showLoading(false);
            });
        },

        showWeixinSettings: function () {
            this.$(".weixin.panel .weixinBasic").addClass('hidden');
            this.$(".weixin.panel .weixinAdvanced").removeClass('hidden');
        },

        cashWithdrawal: function () {
            var amountInput = this.$('.withdrawalInput'), self = this;
            if (!amountInput.val() || amountInput.val() % 1 != 0) {
                alert(i18n.msg('pos.settings.weixin.withdrawal.error.decimal'));
                return;
            }

            POS.showLoading(true);
            var result = $.post('/pingPay/accountWithdrawal', {
                restaurantId: POS.getRestaurant().id,
                amount: amountInput.val() * 100
            });

            result.done(res => {
                if (res.success) {
                    self.$('.weixinBasic .total').text(res.total);
                    self.$('.weixinBasic .clearedTotal').text(res.clearedTotal);
                    amountInput.val("");
                    alert(res.message);

                } else {
                    if(res.reason){
                        alert(i18n.msg("pos.membership.not.enough"));
                        return;
                    }
                    var model = new Backbone.Model();
                    var createrWeixinStaffEl = $(Create_weixinstaff_el(res));
                    var modalView = new ModalView({
                        body:createrWeixinStaffEl,
                        model:model,
                        hideFooter: res.weixinStaffs.length==0
                    }).render();
                    modalView.listenToOnce(model,"change:shouldConfirm",function(modal){
                        var result = $.post('/pingPay/weixinUserAccountWithdrawal', {
                            userId: createrWeixinStaffEl.find('.staff-select').val(),
                            amount: amountInput.val() * 100
                        });
                        result.done(res =>{
                            if (res.success) {
                                self.$('.weixinBasic .total').text(res.total);
                                self.$('.weixinBasic .clearedTotal').text(res.clearedTotal);
                                amountInput.val("");
                                alert(res.message);
                            }
                        });
                        result.fail(res =>{
                            alert('提现失败,请联系客服');
                        })
                    });
                }
            });

            result.fail(res => {
                alert('提现失败,请联系客服');
            });

            result.always(() => POS.showLoading(false));
        }
    });
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/settings/RestaurantSettingView.js